import { FilePdfOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import Modal from 'antd/lib/modal/Modal';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

export const MonthExport = ({ showModal = false, onCancel, children, fileName = 'invoice' }) => {
  const { t } = useTranslation();
  const contentRef = useRef(null);

  const handleDownloadPDF = async () => {
    if (!contentRef.current) return;

    try {
      // Hide the modal temporarily for better capture
      const modal = contentRef.current.closest('.ant-modal-content');
      if (!modal) return;

      // Capture the content as canvas
      const canvas = await html2canvas(contentRef.current, {
        scale: 2,
        useCORS: true,
        logging: false,
        backgroundColor: '#ffffff',
      });

      const imgData = canvas.toDataURL('image/png');
      const imgWidth = 210; // A4 width in mm
      const pageHeight = 297; // A4 height in mm
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;

      const pdf = new jsPDF('p', 'mm', 'a4');
      let position = 0;

      // Add first page
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      // Add additional pages if content is longer than one page
      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      // Download the PDF
      pdf.save(`${fileName}.pdf`);
    } catch (error) {
      console.error('Error generating PDF:', error);
    }
  };

  return (
    <Modal
      open={showModal}
      id="MonthExport"
      onCancel={onCancel}
      styles={{ minHeight: '50vh', padding: 16, borderRadius: '20px' }}
      width="auto"
      footer={[
        <Button key="cancel" onClick={onCancel}>
          {t('common.cancel')}
        </Button>,
        <Button key="download" type="primary" icon={<FilePdfOutlined />} onClick={handleDownloadPDF}>
          {t('salary.downloadPDF')}
        </Button>,
      ]}
      centered
      destroyOnHidden
    >
      <div ref={contentRef} style={{ backgroundColor: 'white', textAlign: 'center' }}>
        {children}
      </div>
    </Modal>
  );
};
